import * as React from "react"
import styled from "styled-components"
import { scale, colors, breakpoint } from "../../styles"
import { Text } from "../Text"
import { space, SpaceProps } from "../../styles/styled-system"
import { Link } from "react-router-dom"

export interface BreadcrumbsProps extends SpaceProps {
	links?: BreadcrumbsLink[]
}

export interface BreadcrumbsLink {
	title: string
	url: string
}

const BreadcrumbsStyled = styled.nav.attrs({
	"aria-label": "Breadcrumb",
})`
	${space}
`

const BreadcrumbsItemStyled = styled.li`
	position: relative;
	display: inline-block;

	&.hidden-desktop {
		${breakpoint("m")`
			display: none;
		`}
	}

	&.hidden-mobile {
		display: none;

		${breakpoint("m")`
			display: inline;
		`}
	}

	&:not(:last-child):after {
		content: "\\002F";
		padding: 0 ${scale.px(0.75)};
		font-size: ${scale.px(1.5)};
		color: ${colors.blue33};
	}
`
const BreadcrumbsLinkStyled = styled(Link).withConfig({
	shouldForwardProp: (prop: any, defaultValidatorFn: any) =>
		![
			"lineHeight",
			"fontWeight",
			"fontSize",
			"display",
			"mr",
			"whitespace",
			"textColor",
			"variant",
		].includes(prop) && defaultValidatorFn(prop),
})`
	font-size: ${scale.px(1.75)};
	line-height: ${scale.px(2.5)};
	text-decoration: none;

	&:hover {
		color: ${colors.hoverBlue};
		text-decoration: underline;
	}
`

const BreadcrumbsExpandBtnStyled = styled.span`
	cursor: pointer;
	font-size: ${scale.px(1.75)};
	color: ${colors.navy};
`

const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
	const { links, ...rest } = props
	const [isExpanded, setExpandedState] = React.useState(false)
	const toggleExpandedState = () => setExpandedState(!isExpanded)

	return (
		<BreadcrumbsStyled {...rest}>
			<ul>
				{links.map((link, index) => {
					const lastLink = index === links.length - 1
					const intermediateItem =
						links.length > 2 && index !== 0 && index !== links.length - 1

					return (
						<React.Fragment key={link.url + index}>
							{index === 1 && links.length > 2 && !isExpanded && (
								<BreadcrumbsItemStyled
									className="hidden-desktop"
									onClick={toggleExpandedState}
								>
									<BreadcrumbsExpandBtnStyled>...</BreadcrumbsExpandBtnStyled>
								</BreadcrumbsItemStyled>
							)}
							<BreadcrumbsItemStyled
								className={`${
									intermediateItem && !isExpanded ? "hidden-mobile" : ""
								}`}
							>
								{lastLink ? (
									<Text
										display="inline"
										fontSize={1.75}
										lineHeight={2.5}
										mb={0}
									>
										{link.title}
									</Text>
								) : (
									<BreadcrumbsLinkStyled
										to={link?.url ?? "#"}
										aria-current={lastLink ? "page" : null}
									>
										{link.title}
									</BreadcrumbsLinkStyled>
								)}
							</BreadcrumbsItemStyled>
						</React.Fragment>
					)
				})}
			</ul>
		</BreadcrumbsStyled>
	)
}

export { Breadcrumbs }
